import React from 'react'
import {Header, Label, List} from 'semantic-ui-react'

const CleanUpOrphanedResponses = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Clean Up Orphaned Responses</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version/environment/resource you'd like to review</List.Item>
        <List.Item>2. Click on the "Responses" tab</List.Item>
        <List.Item>3. Review the "Last Used" column</List.Item>
        <List.Item>4. This column displays the last date the response was returned or "n/a" if it hasn't been returned
          yet. </List.Item>
        <List.Item>
          5. This column will also conditionally displays time based usage warnings:
          <div style={{maxWidth: '425px', marginTop: '10px'}}>
            <List relaxed bulleted divided>
              <List.Item>If the response hasn't been used in 30 days it will show: <Label circular primary
                                                                                          empty
                                                                                          style={{float: 'right'}}/></List.Item>
              <List.Item>If the response hasn't been used in 15 days it will show: <Label circular color='orange'
                                                                                          empty
                                                                                          style={{float: 'right'}}/></List.Item>
              <List.Item>If the response hasn't been used in 7 days it will show: <Label circular color='yellow'
                                                                                         empty
                                                                                         style={{float: 'right'}}/></List.Item>
            </List>
          </div>
        </List.Item>
      </List>
    </div>
  )
}

export {CleanUpOrphanedResponses}

export default CleanUpOrphanedResponses